/* eslint-disable */
/**
 * Trust All Scripts
 *
 * This is a dirty little script for iterating over script tags
 * of your Ghost posts and adding them to the document head.
 *
 * This works for any script that then injects content into the page
 * via ids/classnames etc.
 *
 */
// const { datadogRum } = require('@datadog/browser-rum')
// const $ = require('jquery')
const axios = require('axios')
const { IsMobileProvider } = require('./src/context/isMobileContextApi')

let headerStickHandler = null

var customScripts = function () {
  
    var popupRequestdemo = localStorage.getItem('showMsg')
    if (popupRequestdemo == 'false') {
      var footerb = document.getElementById('footerb')
      if (footerb) footerb.classList.remove('popupspc')
    }

    document.querySelectorAll('.mobile_listing').forEach(function (el) {
      el.addEventListener('click', function () {
        var menu = el.querySelector('.dropdownmenu')
        if (menu) menu.classList.toggle('mobileMenuD')
      })
    })

    document.querySelectorAll('.listingMenu > a').forEach(function (a) {
      a.addEventListener('click', function (event) {
        event.preventDefault()
      })
    })

    // Remove existing scroll listener to prevent memory leaks
    if (headerStickHandler) {
      window.removeEventListener('scroll', headerStickHandler)
    }
    // Add scroll listener only if header_stick exists
    var headerStick = document.querySelector('.header_stick')
    if (headerStick) {
      headerStickHandler = function () {
        if (window.scrollY) {
          headerStick.classList.add('navbar_fixed')
        } else {
          headerStick.classList.remove('navbar_fixed')
        }
      }
      window.addEventListener('scroll', headerStickHandler)
    }


    document.querySelectorAll('nav .navbar-nav a').forEach(function (a) {
      if (a.href === window.location.href) {
        a.classList.add('active')
      }
    })

    document.querySelectorAll('.mobileheader_menu li a').forEach(function (a) {
      a.addEventListener('click', function () {
        var collapse = document.querySelector('.mobile_navbar .navbar-collapse')
        if (collapse) collapse.classList.toggle('show')
      })
    })
    document.querySelectorAll('.scrollToDownload').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault()
        var href = el.getAttribute('href')
        var target = document.querySelector(href)
        if (target) {
          var offset = target.getBoundingClientRect().top + window.pageYOffset - 130
          window.scrollTo({ top: offset, behavior: 'smooth' })
        }
      })
    })
    document.querySelectorAll('.scrollto').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault()
        var href = el.getAttribute('href')
        var target = document.querySelector(href)
        if (target) {
          var offset = target.getBoundingClientRect().top + window.pageYOffset - 250
          window.scrollTo({ top: offset, behavior: 'smooth' })
        }
      })
    })
  }


var trustAllScripts = function () {
  var scriptNodes = document.querySelectorAll('.load-external-scripts script')

  for (var i = 0; i < scriptNodes.length; i += 1) {
    var node = scriptNodes[i]
    var s = document.createElement('script')
    s.type = node.type || 'text/javascript'

    if (node.attributes.src) {
      s.src = node.attributes.src.value
    } else {
      s.innerHTML = node.innerHTML
    }

    document.getElementsByTagName('head')[0].appendChild(s)
  }
  // const urls = ['https://www.vantagefit.io/']
}

/*exit popup*/

const hide = (selector) => {
  document.querySelectorAll(selector).forEach((el) => {
    el.style.display = 'none'
  })
}
const show = (selector, display = 'block') => {
  document.querySelectorAll(selector).forEach((el) => {
    el.style.display = display
  })
}

document.addEventListener('mouseleave', function (e) {
  if (window.innerWidth > 768) {
    leaveFromTop(e)
  }
})

document.addEventListener('DOMContentLoaded', function () {
  hide('#ouibounce-modal .modal')
})

// var showExitPopup
// $('#ouibounce-modal .modal').hide()
function leaveFromTop(e) {
  if (e.clientY < 0) {
    const showExitPopup = sessionStorage.getItem('showExitPopup')
    if (showExitPopup !== 'false') {
      show('#ouibounce-modal')
      show('#ouibounce-modal .modal')
    }
    const closeBtn = document.querySelector('#ouibounce-modal .close .cross')
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        hide('#ouibounce-modal .modal')
        sessionStorage.setItem('showExitPopup', 'false')
        hide('.underlay')
        hide('#ouibounce-modal')
      })
    }
    if (showExitPopup == 'false') {
      hide('#ouibounce-modal .modal')
      hide('.underlay')
      hide('#ouibounce-modal')
    }
  }
}

exports.onRouteUpdate = function () {
  trustAllScripts()
  customScripts()
}

//add  revenueHero script
const { 
  initPerformanceOptimizations, 
  loadGTMOptimized, 
  checkCountryOptimized 
} = require('./src/utils/thirdPartyOptimizer');

exports.onClientEntry = () => {
  // Initialize performance optimizations immediately
  initPerformanceOptimizations();
  
  //cookie consent with optimized country check
  checkCountryOptimized().then((country) => {
    let allowCookie = false
    let showConsentBar = true
    let storedState = JSON.parse(localStorage.getItem('cookieConsentConfig'))
    if (storedState == null) {
      setInitialLocalStorageStates(country, allowCookie, showConsentBar)
    }
    let gdprSessionStorageState = window.sessionStorage.getItem('allowGtm')

    if (gdprSessionStorageState == 'true') {
      loadGTMOptimized('TDN6QG5')
    }

    createCustomEventToCheckLocalStorageChanges()
    window.addEventListener(
      'storage',
      () => {
        let gdprSessionStorageState = window.sessionStorage.getItem('allowGtm')
        if (gdprSessionStorageState == true) {
          loadGTMOptimized('TDN6QG5')
        } else {
          return
        }
      },
      false
    )
  })

  // Revenue Hero and HubSpot are now loaded optimally by the performance optimizer
  // if (typeof window !== "undefined") {
  //     executeRevenueHeroScript();
  // }

  // REMOVING SOME TAGS FROM PARAMS
  const params = new URLSearchParams(window.location.search)
  if (
    params.has('__hstc') ||
    params.has('__hssc') ||
    params.has('__hsfp') ||
    params.has('ref=') ||
    params.has('utm_')
  ) {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    document.head.appendChild(meta)
  }
  // // Initialize Datadog RUM
  // if (typeof window !== 'undefined') {
  //   datadogRum.init({
  //     applicationId: '63ac863a-9913-4c87-889c-c80e82737392',
  //     clientToken: 'pub71eb8f8bfbd534889ba31d570b82b16b',
  //     site: 'us5.datadoghq.com',
  //     service: 'vantagefit',
  //     env: 'prod',
  //     sessionSampleRate: 100,
  //     sessionReplaySampleRate: 20,
  //     trackUserInteractions: true,
  //     trackResources: true,
  //     trackLongTasks: true,
  //     defaultPrivacyLevel: 'mask-user-input',
  //   })
  // }
}

//revenue hero code
function executeRevenueHeroScript() {
  var targetFormIds = [
    `517ebc0a-e3b2-48e7-994d-19507b711e00`,
    `c169c509-7422-4098-bdd2-085a67d82092`,
    `e23ab1ed-02c7-42c1-90bc-ecd78ae786c3`,
    `3ba0360d-0fb0-4473-84c9-a7362657431c`,
    `568567fd-2abb-43a4-b030-a6e2d7875387`,
  ]
  if (typeof window === 'undefined') return
  if (window.addEventListener) {
    window.addEventListener('message', handleFormSubmitEvent, false)
  } else if (window.attachEvent) {
    window.attachEvent('onmessage', handleFormSubmitEvent)
  }
  function handleFormSubmitEvent(event) {
    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
      var submittedData = event.data.data.submissionValues
      var formId = event.data.id
      console.log(formId)
      // Check if the submitted form's ID is in the targetFormIds array
      if (targetFormIds.includes(formId)) {
        var formValues = event.data.data.submissionValues
        //replace routerID with the router ID you've setup
        const RevenueHero = window.RevenueHero
        const hero = new RevenueHero({ routerId: `1226` })
        hero.submit(formValues).then((sessionData) => {
          hero.dialog.open(sessionData)
        })
      }
    }
  }
}

//default id for english site
let setID = `TDN6QG5`

const setGtm = () => {
  insertJS()
}

const addgtmLink = `https://www.googletagmanager.com/gtm.js?id=GTM-${setID}`

//add gtm
const insertJS = () => {
  const addIframe = (src) => {
    const noscript = document.createElement('noscript')
    const iframe = document.createElement('iframe')
    iframe.src = src
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'
    noscript.appendChild(iframe)
    document.body.appendChild(noscript)
  }
  const insertF = () => {
    const script = document.createElement('script')
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-${setID}');`
    document.head.appendChild(script)
  }

  addIframe(addgtmLink)
  insertF()
}

// This function is now replaced by checkCountryOptimized in thirdPartyOptimizer.js
// const checkCurrCountry = checkCountryOptimized

const createCustomEventToCheckLocalStorageChanges = () => {
  var evt = document.createEvent('StorageEvent')
  evt.initStorageEvent('storage', false, false, 'allowGtm', 'oldValue', 'newValue', null, window.localStorage)
  window.dispatchEvent(evt)
}

const setInitialLocalStorageStates = (...args) => {
  const [country, allowCookie, showConsentBar] = args
  let initialObj = JSON.stringify({
    showConsentBar: showConsentBar,
    allowCookie: allowCookie,
    country: country,
  })
  localStorage.setItem('cookieConsentConfig', initialObj)
  sessionStorage.setItem('allowGtm', 'false')
  console.log('run', initialObj)
}

exports.wrapRootElement = ({ element }) => {
  return <IsMobileProvider>{element}</IsMobileProvider>
}
